import { Address } from '../service/AddressHelper/AddressHelper';

import { PhoneNumberData, WorkPeriodInfo } from './banners';
import { ValidationErrorData } from './common';
import { GdOrganizationStatusPublish } from './graphql-grid';

export enum OrganizationsEditorDataStatus {
    EMPTY = 'EMPTY',
    LOADING = 'LOADING',
    SAVING = 'SAVING',
    LOADED = 'LOADED',
    ERROR = 'ERROR',
    NOT_FOUND = 'NOT_FOUND',
    SUGGESTED = 'SUGGESTED'
}

export interface OrganizationData {
    id: string;
    name: string;
    status: GdOrganizationStatusPublish;
    address?: Address;
    phone?: PhoneNumberData;
    website?: string;
    rubric?: string;
    editUrl: string;
    profileUrl: string;
    workTimes?: Array<WorkPeriodInfo>;
}

export interface OrganizationsEditorState {
    organizationId?: string;
    suggestedOrganizationId?: string;
    dataStatus: OrganizationsEditorDataStatus;
    isOpen: boolean;
    bulkActionType?: OrganizationsBulkActionType;
    errors?: ValidationErrorData[];
}

export interface OrganizationEditorParams {
    editorKey: string;
    organizationId?: string;
    suggestedOrganizationId?: string;
}

export type OrganizationsEditorsState = Record<string, OrganizationsEditorState>;

export enum OrganizationsBulkActionType {
    EDIT = 'EDIT',
    DELETE = 'DELETE'
}

export type OrganizationsDataState = Record<string, OrganizationData>;
